import React from 'react'

const DataPribadi = React.lazy(() => import('./DataPribadi'))

export const dataPribadiConfigs = [
    {
        path: '/data-pribadi',
        element: <DataPribadi />,
    },
    {
        path: '/data-pribadi/tab/:tab',
        element: <DataPribadi />,
    },
]
